let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9wqoR")).then(() => parcelRequire('8PIa7'));